module.exports = __webpack_public_path__ + "assets/img/Singapore Science Park I & II.bc9d7938.jpg";